import { Table as MuiTable, styled } from '@mui/material';
import { Card, CardTitle } from '../../../shared/card/card.style';
import { LoadingButton } from '@mui/lab';

export { Card, CardTitle };

export const PatientProfilePageWrapper = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
  fontFamily: 'Roboto',
  fontSize: '12px',
  letterSpacing: '0.15px',
  color: 'rgba(28, 61, 100, 1)',
  backgroundColor: 'rgba(243, 245, 247, 0.6)',
  cursor: 'default',
  flexGrow: 1,
  display: 'grid',
  gridTemplateColumns: '1fr 434px',
  gap: 0
});

export const Content = styled('div')({
  margin: 0,
  padding: '20px 50px',
  overflow: 'auto'
});

export const Table = styled(MuiTable)({
  margin: '0px -16px -16px',
  width: 'calc(100% + 32px)',
  '& .MuiTableHead-root': {
    borderLeft: '24px solid rgba(243, 245, 247, 0.6)',
    borderRight: '24px solid rgba(243, 245, 247, 0.6)',
    background: 'rgba(243, 245, 247, 0.6)',
    '& .MuiTableCell-root': {
      color: '#000000',
      fontWeight: 400,
      fontSize: 14,
      padding: '2px 0px'
    }
  },
  '& .MuiTableBody-root': {
    '& .MuiTableCell-root': {
      '&:first-child': {
        paddingLeft: 13
      },
      '&:last-child': {
        paddingRight: 13
      },
      padding: '14px 0px',
      fontWeight: 400,
      fontSize: 14,
      borderBottom: '1px solid #E6E6E6'
    },
    '& .MuiTableRow-root:last-child .MuiTableCell-root': {
      borderBottom: 'none'
    }
  }
});

export const Separator = styled('div')({
  borderRadius: 4,
  backgroundColor: 'rgba(243, 245, 247, 0.6)',
  fontSize: 14,
  fontWeight: 400,
  padding: '2px 8px',
  letterSpacing: 0.15,
  marginBottom: 4
});

export const Button = styled(LoadingButton)({
  fontSize: 12,
  textTransform: 'initial',
  fontWeight: '600 !important',
  marginRight: 16,
  color: '#000 !important',
  textDecoration: 'none !important',
  border: '1px solid #000',
  padding: '6px 15px',
  borderRadius: 4,
  display: 'inline-flex',
  alignItems: 'center',
  backgroundColor: 'white',
  '.MuiSvgIcon-root': {
    width: 18,
    height: 18,
    marginLeft: 8,
    marginRight: -8
  },
  '&.outlined': {
    border: '1px solid #D9D9D9',
    borderRadius: 4,
    padding: '2px 7px'
  },
  '&.disabled, &.Mui-disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  '&:hover': { backgroundColor: 'rgba(243, 245, 247, 0.6)' }
});
